@switch (columnName) {
  @case ('name') {
    {{ form.firstName.value + ' ' + form.lastName.value }}
  }
  @case ('phoneNumber') {
    {{ form.prefix.value + ' ' + form.phoneNumber.value }}
  }
  @case ('edit') {
    @if (!hideButtons) {
      <app-ui-button
        buttonType="icon-button"
        icon="edit"
        [ariaLabel]="'edit' | translate"
        (click)="buttonFunctions.edit()"
      ></app-ui-button>
    }
  }
  @case ('delete') {
    @if (!hideButtons) {
      <app-ui-button
        buttonType="icon-button"
        icon="delete"
        [ariaLabel]="'delete' | translate"
        (click)="buttonFunctions.delete()"
      ></app-ui-button>
    }
  }
  @default {
    {{ form.get(columnName)?.value }}
  }
}
